import cardImg from "../../assets/images/urban/img-02.jpg";
const Card = ({ data }) => {
  const { title, description, imgUrl } = data;
  const [firsWord, ...restWords] = title.split(" ");
  return (
    <div className="space-y-2 md:space-y-3 cursor-pointer hover:scale-95 transition-all">
      <div className="aspect-video">
        <img
          src={imgUrl}
          alt="card image"
          className="w-full h-full object-cover"
        />
      </div>

      <h5 className="text-xl md:text-2xl flex gap-2 leading-none ">
        <span className="text-[#e60000]">{firsWord}</span>
        {restWords.join("")}
      </h5>
      <p className="leading-none">{description}</p>
    </div>
  );
};

export default Card;
